// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ResearchInterestTags-cls1__ed0c743c07fb50d07104{/*!*/}.ResearchInterestTags-cls2___f9084eb3ada7bba2f1c{height:20px;color:#595959;font-size:12px;letter-spacing:.3px;text-indent:11px;font-weight:400}@media screen and (min-width: 992px){.ResearchInterestTags-cls2___f9084eb3ada7bba2f1c{order:-1;margin-top:-20px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "ResearchInterestTags-cls1__ed0c743c07fb50d07104",
	"cls2": "ResearchInterestTags-cls2___f9084eb3ada7bba2f1c ResearchInterestTags-cls1__ed0c743c07fb50d07104"
};
export default ___CSS_LOADER_EXPORT___;
